define("powergen/controllers/system",
  [],
  function() {
    "use strict";
    var SystemController;

    SystemController = Ember.ObjectController.extend({
      actions: {
        selectImprovement: function(improvement) {
          var msg, partList, partListWrapped;
          switch (improvement.get('part.type.id')) {
            case 'component':
              if (!this.get('pumpIsSelected') || !this.get('motorIsSelected')) {
                msg = 'A pump and motor must be selected first';
                this.set('warningMessage', msg);
                return;
              }
              break;
            case 'motor':
              if (!this.get('pumpIsSelected')) {
                msg = 'A pump must be selected first';
                this.set('warningMessage', msg);
                return;
              }
          }
          partList = this.get('partList').filterBy('type.id', improvement.get('part.type.id'));
          partListWrapped = partList.map(function(part) {
            return Ember.Object.create({
              selected: improvement.get('selectedPart') === part ? true : false,
              part: part
            });
          });
          this.setProperties({
            'selectedImprovement': improvement,
            'selectedImprovement.partList': partListWrapped,
            'warningMessage': ''
          });
          if (this.get('improvementsComplete') && this.get('isSubmitted')) {
            return this.set('showImprovementAnswerOverlay', true);
          } else {
            return this.set('showImprovementOverlay', true);
          }
        },
        selectPartForImprovement: function(context) {
          var improvement, part;
          improvement = context.improvement, part = context.part;
          return improvement.set('selectedPart', part);
        },
        submit: function() {
          if (!this.get('improvementsComplete')) {
            return;
          }
          return this.setProperties({
            'isComplete': true,
            'isSubmitted': true,
            'showImprovementOverlay': false
          });
        },
        next: function() {
          return this.set('showSystemCompleteOverlay', true);
        },
        backToSystems: function() {
          return this.transitionToRoute('systems');
        },
        viewDidClick: function(e) {
          var $target;
          $target = $(e.target);
          if (this.get('showImprovementOverlay') && !this.hasClass($target, 'improvement') && !this.hasClass($target, 'improvement-overlay')) {
            this.setProperties({
              'showImprovementOverlay': false
            });
          }
          if (this.get('showImprovementAnswerOverlay') && !this.hasClass($target, 'improvement') && !this.hasClass($target, 'improvement-answer-overlay')) {
            return this.setProperties({
              'showImprovementAnswerOverlay': false
            });
          }
        }
      },
      correctImprovements: (function() {
        var correct;
        correct = this.get('improvements').filter(function(improvement) {
          return improvement.get('isCorrect') === true && !improvement.get('isCorrected');
        });
        this.setProperties({
          'points': correct.get('length') * 1000
        });
        return correct;
      }).property('improvements.@each.isCorrect'),
      partList: (function() {
        return this.sortParts('name', this.get('store').all('part').get('content'));
      }).property(),
      sortParts: function(key, arr) {
        return arr.sort(function(a, b) {
          if (a.get(key) < b.get(key)) {
            return -1;
          }
          if (a.get(key) > b.get(key)) {
            return 1;
          }
        });
      },
      selectedImprovement: null,
      showImprovementOverlay: false,
      showImprovementAnswerOverlay: false,
      showSystemOverlay: true,
      showSystemCompleteOverlay: false,
      isSubmitted: false,
      improvementsComplete: (function() {
        return !this.get('improvements').anyBy('selectedPart', null);
      }).property('improvements.@each.selectedPart'),
      pumpIsSelected: (function() {
        return !this.get('improvements').filterBy('part.type.id', 'pump').anyBy('selectedPart', null);
      }).property('improvements.@each.selectedPart'),
      motorIsSelected: (function() {
        return !this.get('improvements').filterBy('part.type.id', 'motor').anyBy('selectedPart', null);
      }).property('improvements.@each.selectedPart'),
      warningMessage: '',
      hasClass: function($element, className) {
        if ($element.hasClass(className) || $element.parents("." + className).length > 0) {
          return true;
        } else {
          return false;
        }
      },
      reset: function() {
        return this.setProperties({
          'selectedImprovement': null,
          'showImprovementOverlay': false,
          'showImprovementAnswerOverlay': false,
          'showSystemOverlay': true,
          'showSystemCompleteOverlay': false,
          'isSubmitted': false
        });
      }
    });


    return SystemController;
  });